<template>
  <div class="container">
    <img src='../assets/404.png'/>
    <div class="err-word">您访问的页面不存在...</div>
    <lk-button type="primary" @click="backToLast">返回上一页</lk-button>
  </div>
</template>
<script>
export default {
  name: 'error',
  methods: {
    backToLast() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.container{
  height: calc(100vh - 112px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

}
.err-word{
  margin-bottom: 16px;
}
</style>
